import axios from 'axios'
import { v4 as uuid } from 'uuid'
import { CADASTRAR_RESERVA, VERIFICAR_PAGAMENTO, PAGAR_FORMA_PAGAMENTO, GERAR_LINK_PAGAMENTO_PEDIDO, GERAR_QRCODE_CIELO_ECOMMERCE_PEDIDO, GERAR_QRCODE_SICOOB_PEDIDO, CANCELAR_ENVIO_STONE_CONNECT, VENDA_SALVA_OFFLINE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER, handleResponseError } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'
import { salvarVendaOffline } from '../../util/offlineStorage'
import { registrarSyncVendas } from '../../registerServiceWorker'
import { getUsuarioHabilitadoVendaOffline } from '../../security/securityContext'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

// Erro "esperado": não é falha de sistema, é a regra de negócio bloqueando a
// venda offline para quem não está habilitado. err.offline=true reaproveita o
// tratamento que os componentes já fazem (showErrorMsg com err.message).
function erroVendaOfflineNaoHabilitada() {
  const err = new Error(
    'Empresa ou usuário não habilitados para venda offline. Verifique sua internet e tente novamente.'
  )
  err.offline = true
  return Promise.reject(err)
}

export function cadastrarReserva(crirReserva) {
  const url = `${URL}/reserva/cadastrar/terminal-venda`
  const idChaveOffline = uuid()

  return async (dispatch, getState) => {
    const state = getState()
    const v  = state.viagemIda
    const vv = state.viagemVolta
    const dadosViagem = {
      empresaNome: state.empresaSelecionada && state.empresaSelecionada.nome,
      origemNome:  state.origem  && state.origem.nomeComUf,
      destinoNome: state.destino && state.destino.nomeComUf,
      ida: v ? {
        nomeEmpresa:     v.nomeEmpresa,
        descRota:        v.descRota,
        horaPartida:     v.horaPartida,
        dataPartida:     v.dataPartida,
        dataHoraPartida: v.dataHoraPartida,
        embarque:        v.embarque,
        veiculo:         v.veiculo,
        nomePrestador:   v.nomePrestador,
        idItinerario:    v.idItinerario,
      } : null,
      volta: vv ? {
        nomeEmpresa:     vv.nomeEmpresa,
        descRota:        vv.descRota,
        horaPartida:     vv.horaPartida,
        dataPartida:     vv.dataPartida,
        dataHoraPartida: vv.dataHoraPartida,
        embarque:        vv.embarque,
        veiculo:         vv.veiculo,
        nomePrestador:   vv.nomePrestador,
        idItinerario:    vv.idItinerario,
      } : null,
    }

    const vendaComChave = { ...crirReserva, idChaveOffline, dadosViagem }
    const empresaId = state.empresaSelecionada && state.empresaSelecionada.id

    if (!navigator.onLine) {
      if (!getUsuarioHabilitadoVendaOffline(empresaId)) {
        return erroVendaOfflineNaoHabilitada()
      }
      await salvarVendaOffline(vendaComChave)
      await registrarSyncVendas()
      return dispatch({ type: VENDA_SALVA_OFFLINE, payload: idChaveOffline })
    }

    return axios.post(url, vendaComChave, OFFLINE_AWARE_CONFIG)
      .then(response => dispatch({ type: CADASTRAR_RESERVA, payload: response }))
      .catch(async error => {
        if (!error.response) {
          if (!getUsuarioHabilitadoVendaOffline(empresaId)) {
            return erroVendaOfflineNaoHabilitada()
          }
          await salvarVendaOffline(vendaComChave)
          await registrarSyncVendas()
          return dispatch({ type: VENDA_SALVA_OFFLINE, payload: idChaveOffline })
        }
        handleResponseError(error.response.data)
        throw error
      })
  }
}

export function pagarPedido(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-tef`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function pagarPedidoLink(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-link-pagamento`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function pagarFormaPagamentoPedido(idFormaPagamento, idEmpresa) {
    const url = `${URL}/reserva/empresa/${idEmpresa}/pagar-forma-pagamento/${idFormaPagamento}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: PAGAR_FORMA_PAGAMENTO,
            payload: response
        })
    );
}

export function gerarLinkPagamentoPedidoExistente(pedidoId, empresaId) {
    const url = `${URL}/reserva/pedido/${pedidoId}/gerar-link-pagamento?empresaId=${empresaId}`;
    return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: GERAR_LINK_PAGAMENTO_PEDIDO,
            payload: response
        })
    );
}

export function gerarQrcodePixCieloEcommercePedidoExistente(pedidoId, empresaId) {
    const url = `${URL}/reserva/pedido/${pedidoId}/gerar-qrcode-cielo-ecommerce?empresaId=${empresaId}`;
    return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: GERAR_QRCODE_CIELO_ECOMMERCE_PEDIDO,
            payload: response
        })
    );
}

export function pagarPedidoCieloEcommerce(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-cielo-ecommerce`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function pagarPedidoSicoob(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-sicoob`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function pagarPedidoStoneConnect(crirReserva) {
    const url = `${URL}/reserva/cadastrar/terminal-venda-stone-connect`;
    return dispatch => axios.post(url, crirReserva, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_RESERVA,
            payload: response
        })
    );
}

export function gerarQrcodePixSicoobPedidoExistente(pedidoId, empresaId) {
    const url = `${URL}/reserva/pedido/${pedidoId}/gerar-qrcode-sicoob?empresaId=${empresaId}`;
    return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: GERAR_QRCODE_SICOOB_PEDIDO,
            payload: response
        })
    );
}

// Botão "Cancelar" (Vender Passagens) / "Cancelar envio Stone Connect" (Gerenciar Pedidos) --
// cancela um pedido Stone Connect enviado mas ainda não confirmado (NÃO estorna cobrança já
// aprovada). Ver plano em demanda-a-fazer/stone-connect-cancelamento-pedido-pendente/.
export function cancelarPedidoStoneConnect(pedidoId, empresaId) {
    const url = `${URL}/reserva/pedido/${pedidoId}/cancelar-envio-stone-connect?empresaId=${empresaId}`;
    return dispatch => axios.post(url, {}, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CANCELAR_ENVIO_STONE_CONNECT,
            payload: response
        })
    );
}

export function verificarPagamento(idPedido, formaPagamento) {
    const url = `${URL}/reserva/pedido/${idPedido}/forma-pagamento/${formaPagamento}/status`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: VERIFICAR_PAGAMENTO,
            payload: response
        })
    );
}

